import React from 'react'
import PropTypes from 'prop-types'
import * as Icon from 'react-feather'

const IsLandingTableBadge = ({ page, classes, updateLandingPage }) => {
  return (
    <div>
      {page.status === 'published' ? (
        page.landing ? (
          <span
              onClick={() => {
                updateLandingPage(page._id)
              }}
              className={`c-badge ${classes.badgeSuccess} u-m-xsmall c-badge--small has-arrow`}>
            <Icon.Check size={10} /> Current
          </span>
        ) : (
          <span
            onClick={() => {
              updateLandingPage(page._id)
            }}
            className={`c-badge ${classes.badgePrimary} clickable  u-m-xsmall c-badge--small has-arrow`}
          >
            <Icon.Monitor size={10} /> Set as Landing Page?
          </span>
        )
      ) : (
        <span disabled={'disabled'} className={`c-badge ${classes.badgeSecondary} u-m-xsmall c-badge--small has-arrow`}>
          <Icon.Edit3 size={10} /> Draft Page
        </span>
      )}
    </div>
  )
}

IsLandingTableBadge.propTypes = {
  page: PropTypes.object,
  classes: PropTypes.object,
  updateLandingPage: PropTypes.func,
}

export default IsLandingTableBadge
